module.exports = __webpack_public_path__ + "img/calendar.05760c90.svg";